import React from 'react';
import { motion } from 'framer-motion';
import { Percent, Gift, Star, Users } from 'lucide-react';
const benefits = [{
  icon: Percent,
  title: 'Descuentos directos',
  description: 'Accede a descuentos exclusivos en productos y servicios de comercios afiliados al programa.',
  color: '#5B9BD5',
  bgColor: '#E8F4F8'
}, {
  icon: Star,
  title: 'Promociones especiales',
  description: 'Disfruta de promociones y ofertas especiales diseñadas exclusivamente para miembros Fullpass.',
  color: '#6B9B5F',
  bgColor: '#F0F7ED'
}, {
  icon: Gift,
  title: 'Obsequios e incentivos',
  description: 'Recibe obsequios y beneficios adicionales según las ofertas de cada comercio aliado.',
  color: '#F4A460',
  bgColor: '#FFF4E6'
}, {
  icon: Users,
  title: 'Servicios preferenciales',
  description: 'Accede a atención prioritaria y servicios preferenciales en el ecosistema emprendedor.',
  color: '#5B9BD5',
  bgColor: '#E8F4F8'
}];
export function BenefitsSection() {
  return <section className="py-24 bg-white" data-id="element-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-10">
          <h2 className="text-4xl font-bold text-[#2C3E50] mb-4" data-id="element-11">
            Beneficios exclusivos
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-12">
            Tu tarjeta Emprende Fullpass te conecta con una red de comercios
            afiliados que ofrecen beneficios diseñados para ti
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-13">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={benefit.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group" data-id="element-14">
                <div className="bg-white rounded-xl p-6 border border-gray-100 hover:shadow-xl transition-shadow duration-300 h-full" data-id="element-15">
                  <div className="w-14 h-14 rounded-lg flex items-center justify-center mb-4" style={{
                backgroundColor: benefit.bgColor
              }} data-id="element-16">
                    <Icon className="w-7 h-7" style={{
                  color: benefit.color
                }} data-id="element-17" />
                  </div>

                  <h3 className="text-xl font-semibold text-[#2C3E50] mb-3" data-id="element-18">
                    {benefit.title}
                  </h3>

                  <p className="text-gray-600 leading-relaxed" data-id="element-19">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-20">
          <p className="text-sm text-gray-500 max-w-3xl mx-auto" data-id="element-21">
            Los beneficios están sujetos a las condiciones particulares de cada
            comercio afiliado. Cada comercio es responsable de aplicar,
            mantener, modificar o cancelar los beneficios que ofrece.
          </p>
        </motion.div>
      </div>
    </section>;
}